import { app } from "./firebase";
import { GoogleAuthProvider, signInWithPopup, getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, FacebookAuthProvider, sendEmailVerification } from "firebase/auth";
import API_SERVICE from "./apiService";

const API_URL = process.env.REACT_APP_API_URL;

const auth = getAuth(app);

const sendTokenToBackendAndGetProfile = async (firebaseToken) => {
  try {
    await fetch(`${API_URL}/auth/v1/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        firebaseToken: firebaseToken,
      }),
    });
    let profile = await API_SERVICE.getProfile();
    return profile;
  } catch (error) {
    console.error("Authentication error:", error);
  }
};

export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: "select_account",
  });
  try {
    const result = await signInWithPopup(auth, provider);
    const token = await result.user.getIdToken();
    return await sendTokenToBackendAndGetProfile(token);
  } catch (error) {
    console.error(error);
  }
};

export const signInWithFacebook = async () => {
  const provider = new FacebookAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    const token = await result.user.getIdToken();
    return await sendTokenToBackendAndGetProfile(token);
  } catch (error) {
    console.error(error);
  }
}

export const signUpWithEmail = async (email, password) => {
  const result = await createUserWithEmailAndPassword(auth, email, password);
  await sendEmailVerification(result.user);
}

export const signInWithEmail = async (email, password) => {
  const result = await signInWithEmailAndPassword(auth, email, password);
  if (!result.user.emailVerified) {
    throw Error ("Error: unverified email. Please check your email for a verification link.");
  }
  const token = await result.user.getIdToken();
  return await sendTokenToBackendAndGetProfile(token);
}

export const resendEmailVerificationLink = async (user) => {
  await sendEmailVerification(user);
}

export const logout = async () => {
  await fetch(`${API_URL}/auth/v1/logout`, {
    method: "POST",
    credentials: "include",
  });
}

export const checkAuth = async () => {
  const response = await fetch(`${API_URL}/auth/v1/me`, {
    method: "GET",
    credentials: "include",
  });
  return response.status === 200;
};
